import { useEffect, useState } from 'react'

export type ColorScheme = 'light' | 'dark'

function currentScheme(): ColorScheme {
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
}

/**
 * The active colour scheme, from the `dark` class the design system toggles on
 * `<html>`.
 *
 * Observed rather than read once, because the class can change after mount, and
 * derived from the class rather than from `prefers-color-scheme` so an explicit
 * choice wins over the operating system's.
 */
export function useColorScheme(): ColorScheme {
  const [scheme, setScheme] = useState<ColorScheme>(currentScheme)

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setScheme(currentScheme())
    })
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    })
    return () => {
      observer.disconnect()
    }
  }, [])

  return scheme
}
